// extracted by mini-css-extract-plugin
export default {"wrapper":"RefineComparisonTableButtons_wrapper__ivDyO","apply":"RefineComparisonTableButtons_apply__5hGlX","filterButtonIcon":"RefineComparisonTableButtons_filterButtonIcon__M39d-"};